export const GOODS_TYPE_ITEMS = [
  { id: 'base', name: 'base' },
  { id: 'first_come', name: 'first_come' },
  { id: 'gacha', name: 'gacha' },
  { id: 'random', name: 'random' },
  { id: 'lucky_draw', name: 'lucky_draw' },
  { id: 'lucky_number', name: 'lucky_number' },
  { id: 'menu', name: 'menu' },
  { id: 'special_day', name: 'special_day' },
  { id: 'hashtag', name: 'hashtag' },
  { id: 'photobooth', name: 'photobooth' },
  { id: 'small_exhibition', name: 'small_exhibition' }
];

export const GOODS_TYPE_ORDER = [
  'base',
  'first_come',
  'gacha',
  'lucky_draw',
  'lucky_number',
  'random',
  'menu',
  'special_day',
  'hashtag',
  'photobooth',
  'small_exhibition'
];

export const GOODS_TYPE_META: Record<string, { title: string; image: string; key: string }> = {
  base: { title: '기본 특전', image: 'Wrapped gift', key: 'base' },
  first_come: { title: '선착순 특전', image: 'Index pointing up', key: 'firstCome' },
  gacha: { title: '갓챠 특전', image: 'Four leaf clover', key: 'gacha' },
  lucky_draw: { title: '럭키 이벤트', image: 'Four leaf clover', key: 'luckyDraw' },
  lucky_number: { title: '럭키 넘버', image: 'Four leaf clover', key: 'luckyNumber' },
  random: { title: '랜덤 특전', image: 'Game die', key: 'random' },
  menu: { title: '메뉴 특전', image: 'Shortcake', key: 'menu' },
  special_day: { title: '당일 특전', image: 'Tear-off calendar', key: 'specialDay' },
  hashtag: { title: '해시태그', image: 'Hash-tag', key: 'hashtag' },
  photobooth: { title: '포토부스', image: 'clapper_board', key: 'photobooth' },
  small_exhibition: { title: '미니 전시', image: 'Exhibition', key: 'smallExhibition' }
};
